import { useCurrency } from "@/context/CurrencyContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Globe2, ChevronDown } from "lucide-react";

const ALL = [
  ["usd","US Dollar"],["eur","Euro"],["gbp","British Pound"],["inr","Indian Rupee"],
  ["jpy","Japanese Yen"],["aud","Australian Dollar"],["cad","Canadian Dollar"],
  ["sgd","Singapore Dollar"],["brl","Brazilian Real"],["aed","UAE Dirham"],
  ["chf","Swiss Franc"],["mxn","Mexican Peso"],["zar","South African Rand"],
  ["hkd","Hong Kong Dollar"],
];

export default function CurrencySelector() {
  const { currency, setCurrency, symbols } = useCurrency();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="currency-selector" className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-stone-200 text-sm hover:border-[#2C5530] transition-colors">
          <Globe2 className="w-3.5 h-3.5"/>
          <span className="font-medium">{currency.toUpperCase()}</span>
          <ChevronDown className="w-3 h-3 opacity-60"/>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white max-h-72 overflow-y-auto">
        {ALL.map(([code, name]) => (
          <DropdownMenuItem
            key={code}
            data-testid={`ccy-${code}`}
            onClick={() => setCurrency(code)}
            className={code === currency ? "bg-stone-100" : ""}
          >
            <span className="mr-2 w-8 text-stone-500">{symbols[code]}</span>
            <span className="uppercase text-xs font-medium mr-2">{code}</span>
            <span className="text-sm">{name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
